import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MoreReviewsButton } from '../../components/MoreReviewsButton';
import { getHasMore } from '../../selectors/pagination';
import { reviewsPaginationRequestAction } from '../../actions/pagination';

export function MoreReviewsButtonContainer(): React.JSX.Element | null {
  const hasMore = useSelector(getHasMore);
  const dispatch = useDispatch();

  const onClick = React.useCallback(() => {
    dispatch(reviewsPaginationRequestAction());
  }, [dispatch]);

  if (!hasMore) {
    return null;
  }

  return <MoreReviewsButton onClick={onClick} />;
}
